import { render, staticRenderFns } from "./WidgetAccordionForm.vue?vue&type=template&id=08dad7ce&scoped=true"
import script from "./WidgetAccordionForm.vue?vue&type=script&lang=js"
export * from "./WidgetAccordionForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetAccordionForm.vue?vue&type=style&index=0&id=08dad7ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dad7ce",
  null
  
)

export default component.exports